export const PRICE_TYPES = {
    REGULAR: 1,
    PART: 2,
    FULL: 3
}